// src/utils/StrUtil.ts

import moment from "moment";

class StrUtil {

    /**
     * 如果字符串长度小于期望长度，在其前方填充给定字符
     * @param input 
     * @param len 
     * @param fillChar 
     */
    fillPrev(input: string, len: number, fillChar: string) {
        let delta:number = len - input.length
        if (delta > 0) {
            for (let i = 0; i < delta; i++) {
                input = fillChar + input
            }
        }
        return input
    }

    /** 转为以K为单位, 保留 fractionDigits 位小数(如果小于0.01K，显示0.01K) */
    toK(num: number, fractionDigits: number = 2) {
        if (num < 10) {
            return '0.01K'
        }
        return (num / 1024).toFixed(fractionDigits) + 'K'
    }

    /** 转为以M为单位, 保留 fractionDigits 位小数(如果小于0.01M，显示0.01M) */
    toM(num: number, fractionDigits: number = 2) {
        if (num < 1024 * 10) {
            return '0.01M'
        }
        return (num / (1024 * 1014)).toFixed(fractionDigits) + 'M'
    }

    /**
     * 格式化时长数据(HH:MM:SS)
     * @param seconds 时长，单位秒
     */
    formatDuration(seconds: number) {
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const secs = seconds % 60;

        return [
            hours.toString().padStart(2, '0'),
            minutes.toString().padStart(2, '0'),
            secs.toString().padStart(2, '0')
        ].join(':');
    }

    /**
     * 格式化时间戳
     * @param miliseconds 时间戳，单位：毫秒
     * @param f 时间格式
     * @returns 
     */
    formatTime(miliseconds: number, f='YYYY-MM-DD HH:mm:ss') {
        return moment(miliseconds).format(f)
    }

}

export let strUtil = new StrUtil()